// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HCdu","colMin":"styles_colMin__3rBKi"};